<script setup lang="ts">

interface Props {
    icon?: string
    active?: boolean
    href?: string
    target?: string
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    icon: undefined,
    active: false,
    href: undefined,
    target: undefined,
    disabled: false,
})
const emit = defineEmits<{ click: [] }>()
</script>

<template>
    <v-list-item
        link
        density="compact"
        nav
        :active="props.active"
        :disabled="props.disabled"
        :href="props.href"
        :target="props.target"
        @click="emit('click')"
    >
        <template #prepend>
            <v-icon size="small">
                {{ props.icon }}
            </v-icon>
        </template>
        <v-list-item-title class="text-body-2">
            <slot />
        </v-list-item-title>
    </v-list-item>
</template>

<style scoped>
:deep(.v-list-item__prepend) {
    width: 36px;
}

.v-list-item--density-compact.v-list-item--one-line {
    min-height: 32px;
}

.v-list-group__items .v-list-item {
    padding-inline-start: 8px !important;
}
</style>
